import Select, { SelectProps } from "@/shared/form/select";
import { useAllDynamicProcessCandidates } from "../../../model/use-all-dynamic-process-candidates";

export function MetaClassSelector({
  isEditMode,
  ...selectProps
}: SelectProps & { isEditMode?: boolean }) {
  const { data } = useAllDynamicProcessCandidates();

  return (
    <Select
      options={data?.getAllDynamicProcessCandidates.map((item) => ({
        label: item.caption,
        value: item.id,
      }))}
      disabled={isEditMode}
      {...selectProps}
    />
  );
}
